module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotDetails) ? _c('b-modal', {
    ref: "missionSlotDetailsModal",
    attrs: {
      "id": "missionSlotDetailsModal",
      "size": "lg",
      "title": _vm.slotDetailsTitle,
      "no-close-on-backdrop": ""
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-1"
  }, [_vm._v("#")]), _vm._v(" "), _c('div', {
    staticClass: "col col-3"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.role')))]), _vm._v(" "), _c('div', {
    staticClass: "col col-5"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.player')))]), _vm._v(" "), _c('div', {
    staticClass: "col col-3"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.difficulty')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-1"
  }, [_vm._v(_vm._s(_vm.missionSlotDetails.orderNumber))]), _vm._v(" "), _c('div', {
    staticClass: "col col-3"
  }, [_vm._v(_vm._s(_vm.missionSlotDetails.title) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "col col-5"
  }, [(_vm.missionSlotDetails.blocked) ? _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.blocked')))]) : _vm._e(), _vm._v(" "), (!_vm.missionSlotDetails.blocked && _vm.missionSlotDetails.assignee) ? _c('span', [_c('router-link', {
    staticClass: "text-success font-weight-bold",
    attrs: {
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.missionSlotDetails.assignee.uid
        }
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.formatUserWithTag(_vm.missionSlotDetails.assignee)) + "\n            ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.missionSlotDetails.blocked && !_vm.missionSlotDetails.assignee && _vm.missionSlotDetails.externalAssignee) ? _c('span', {
    staticClass: "text-success font-weight-bold font-italic"
  }, [_vm._v(_vm._s(_vm.missionSlotDetails.externalAssignee))]) : _vm._e(), _vm._v(" "), (!_vm.missionSlotDetails.blocked && !_vm.missionSlotDetails.assignee && !_vm.missionSlotDetails.externalAssignee && (!_vm.missionSlotDetails.registrationCount || _vm.missionSlotDetails.registrationCount <= 0)) ? _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(("" + (this.$tc('mission.slot.assignee.registration', 0)))))]) : _vm._e(), _vm._v(" "), (!_vm.missionSlotDetails.blocked && !_vm.missionSlotDetails.assignee && !_vm.missionSlotDetails.externalAssignee && _vm.missionSlotDetails.registrationCount && _vm.missionSlotDetails.registrationCount > 0) ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(((this.missionSlotDetails.registrationCount) + " " + (this.$tc('mission.slot.assignee.registration', this.missionSlotDetails.registrationCount > 1 ? 2 : 1)))))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col col-3"
  }, [_c('i', {
    class: _vm.difficultyIcon,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.difficultyColor
  }, [_vm._v(_vm._s(_vm.difficultyText))])])]), _vm._v(" "), _c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col col-6"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.description')))]), _vm._v(" "), _c('div', {
    staticClass: "col col-5"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.status')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col col-6"
  }, [_vm._v(_vm._s(_vm.missionSlotDetails.description))]), _vm._v(" "), _c('div', {
    staticClass: "col col-5",
    domProps: {
      "innerHTML": _vm._s(_vm.slotStatus)
    }
  })]), _vm._v(" "), _c('hr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotDetails.detailedDescription),
      expression: "missionSlotDetails.detailedDescription"
    }],
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotDetails.detailedDescription),
      expression: "missionSlotDetails.detailedDescription"
    }],
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.detailedDescription')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotDetails.detailedDescription),
      expression: "missionSlotDetails.detailedDescription"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12",
    domProps: {
      "innerHTML": _vm._s(_vm.missionSlotDetails.detailedDescription)
    }
  })]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.registrations')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_c('mission-slot-registrations', {
    attrs: {
      "missionSlotDetails": _vm.missionSlotDetails
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [(_vm.loggedIn && !_vm.missionSlotDetails.registrationUid && !_vm.hasMissionEnded) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotRegistrationModal",
      modifiers: {
        "missionSlotRegistrationModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.missionSlotDetails.blocked || !_vm.canRegisterForSlot
    },
    on: {
      "click": _vm.hideMissionSlotDetailsModal
    }
  }, [_c('i', {
    staticClass: "fa fa-ticket",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.register')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotAssignModal",
      modifiers: {
        "missionSlotAssignModal": true
      }
    }],
    attrs: {
      "variant": "warning",
      "disabled": _vm.missionSlotDetails.blocked
    },
    on: {
      "click": _vm.hideMissionSlotDetailsModal
    }
  }, [_c('i', {
    staticClass: "fa fa-gavel",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.assign.mission.slot')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.duplicateMissionSlot
    }
  }, [_c('i', {
    staticClass: "fa fa-files-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.duplicate.mission.slot')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotEditModal",
      modifiers: {
        "missionSlotEditModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.hideMissionSlotDetailsModal
    }
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotDetailsModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.close')) + "\n      ")])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63970d02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionSlotDetailsModal.vue
// module id = 531
// module chunks = 0